// Generated by CoffeeScript 2.7.0
var RefuseCheckBox;

import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js';

export default RefuseCheckBox = Vue.extend({
  components: {
    'dropdown-select': DropdownSelect
  },
  props: {
    refuseMode: {
      type: Number,
      required: true
    },
    refuseReviewersMode: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      options: [1, 2, 3],
      reviewerTypeOptions: [0, 1]
    };
  },
  template: `<div>
  <div v-for="item in options" :key="item" class="operations-list">
    <label class="option-item">
      <input type="checkbox" :checked="refuseMode === item" @click="refuseValueChangeFunc(item)" hidden='true'>
      <i class="slp-square-o"></i>
      <div class="option-label">{{ Skylark.Helpers.getZH_CN('assignment.refuse.' + item) }}</div>
    </label>
    <div class="list-item" v-if="item !== 1 && refuseMode === item">
      <div class="tip">
        <div class="option-item">
          <i class="slp-empty"></i>
          <div class="option-label">方式</div>
        </div>
      </div>
      <div class="content">
        <dropdown-select :optionGroups="[{ options: reviewerTypeOptions }]"
                          customClass='transparent'
                          :initValue='refuseReviewersMode'
                          @change='refuseReviewerChangeFunc'>
          <template slot='value-template' slot-scope='{ option }'>
            <span>{{ Skylark.Helpers.getZH_CN('assignment.refuse.reviewer.' + option) }}</span>
          </template>
          <template slot='option-template' slot-scope='{ option }'>
            <span>{{ Skylark.Helpers.getZH_CN('assignment.refuse.reviewer.' + option) }}</span>
          </template>
        </dropdown-select>
      </div>
    </div>
  </div>
</div>`,
  methods: {
    refuseValueChangeFunc: function(val) {
      return this.$emit('refuseModeChanged', val);
    },
    refuseReviewerChangeFunc: function(val) {
      return this.$emit('refuseReviewersModeChanged', val);
    }
  }
});
